import React, { useState, useRef } from 'react';
import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';

import './App.css';
import unicefLogo from './assets/unicef-logo.png';
import heic2any from 'heic2any';

const baseUrl = window.location.origin;

Font.register({
  family: 'Roboto',
  fonts: [
    { src: `${baseUrl}/komunikacijska-putovnica/fonts/Roboto-Regular.ttf` }, 
    { src: `${baseUrl}/komunikacijska-putovnica/fonts/Roboto-Bold.ttf`, fontWeight: 'bold' },
    { src: `${baseUrl}/komunikacijska-putovnica/fonts/Roboto-Italic-VariableFont_wdth,wght.ttf`, fontStyle: 'italic' }
  ] 
});

Font.registerHyphenationCallback(word => [word]);


const formatirajDatum = (datum) => {
  const [godina, mjesec, dan] = datum.split('-');
  return `${dan}.${mjesec}.${godina}.`; // Vraća format DD.MM.GGGG.
};

const styles = StyleSheet.create({
  page: { padding: 40, paddingTop: 60, paddingBottom: 60, fontFamily: 'Roboto', backgroundColor: '#f0fcff' },
  headerBar: { position: 'absolute', top: 0, left: 0, right: 0, backgroundColor: '#00334D', height: 50, justifyContent: 'center', alignItems: 'center' },
  headerLogo: { height: 35 },
  naslov: { textAlign: 'center', color: '#0077b6', fontSize: 32, fontWeight: 'bold', marginTop: 10 },
  podnaslov: { textAlign: 'center', fontSize: 20, color: '#555', marginBottom: 20 },
  introSection: { flexDirection: 'row', backgroundColor: '#f0f0f0', borderRadius: 10, padding: 20, marginBottom: 20, gap: 20 },
  introLeft: { width: '40%', alignItems: 'center' },
  introRight: { width: '60%', backgroundColor: '#0077b6', color: 'white', padding: 15, borderRadius: 6, fontSize: 11, lineHeight: 1.5 },
  photoPreview: { width: 150, height: 150, borderRadius: 8, backgroundColor: '#ddd', objectFit: 'cover' },
  imeTekst: { marginTop: 10, fontSize: 16, color: '#333' },
  overviewContainer: { gap: 10 },
  overviewRow: { flexDirection: 'row', alignItems: 'center', padding: 12, borderRadius: 8 },
  pinkRow: { backgroundColor: '#facccc' },
  greenRow: { backgroundColor: '#B7ECB7' },
  yellowRow: { backgroundColor: '#FFD366' },
  sectionTitle: { fontSize: 16, fontWeight: 'bold' },
  footer: { position: 'absolute', bottom: 20, left: 40, right: 40, borderTopWidth: 1, borderTopColor: '#ccc', paddingTop: 5, fontSize: 9, color: '#777' }
});


const pdfStyles = StyleSheet.create({
    page: { 
    paddingTop: 50, 
    paddingHorizontal: 40, 
    paddingBottom: 40, 
    fontFamily: 'Roboto', 
    backgroundColor: '#f0fcff' 
  },
  pagePink: { backgroundColor: '#fde8e8' },
  pageGreen: { backgroundColor: '#D9F8D9' },
  pageYellow: { backgroundColor: '#FFD9A0'},
  headerBar: { 
    position: 'absolute', 
    top: 0, 
    left: 0, 
    right: 0, 
    backgroundColor: '#00334D', 
    height: 40, 
    display: 'flex',            
    justifyContent: 'center', 
    alignItems: 'center',
    zIndex: 100                 
  },
  headerLogo: { 
    height: 35, 
    width: 80, 
    objectFit: 'contain',
    opacity: 1 // Forsiramo vidljivost
  },
  footerContainer: {
  position: 'absolute',
  bottom: 20,
  left: 30,
  right: 30,
  borderTop: '1.5pt solid #00334D', // Deblja plava linija iznad
  paddingTop: 8,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
},
footerTextLeft: {
  fontSize: 9,
  color: '#00334D', // Tamnoplava boja teksta
  fontWeight: 'bold',
  letterSpacing: 0.5,
},
footerPageBox: {
  backgroundColor: '#1C355E', // Plavi pravokutnik za broj stranice
  paddingHorizontal: 8,
  paddingVertical: 3,
  borderRadius: 4,
},
footerPageText: {
  fontSize: 9,
  color: '#FFFFFF', // Bijeli tekst na plavoj podlozi
  fontWeight: 'bold',
},
    naslov: { textAlign: 'center', color: '#0077b6', fontSize: 32, fontWeight: 'bold', marginTop: 10 },
    podnaslov: { textAlign: 'center', fontSize: 20, color: '#555', marginBottom: 20 },
    introSection: { flexDirection: 'row', backgroundColor: '#f0f0f0', borderRadius: 10, padding: 20, marginBottom: 20, gap: 20 },
    introLeft: { width: '40%', alignItems: 'center' },
    introRight: { width: '60%', backgroundColor: '#0077b6', color: 'white', padding: 15, borderRadius: 6, fontSize: 10, lineHeight: 1.5, textAlign: 'left' },
    photoPreview: { width: 150, height: 150, borderRadius: 8, backgroundColor: '#ddd' },
    imeTekst: { marginTop: 10, fontSize: 16, fontWeight: 'bold', color: '#333', textAlign: 'center' },
    sectionBanner: { flexDirection: 'row', alignItems: 'center', padding: 8, borderRadius: 8, marginBottom: 8, gap: 10},
    bannerIcon: { width: 80, height: 80},
    footer: { position: 'absolute', bottom: 20, left: 40, right: 40, borderTopWidth: 1, borderTopColor: '#ccc', paddingTop: 5, fontSize: 9, color: '#777', textAlign: 'center' },
    // Novi stilovi za redove na 2. stranici
  fieldRowPink: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff8f8',
    padding: 8,
    borderRadius: 6,
    marginBottom: 6,
    gap: 10,
  },
  fieldRowPinkAlignStart: {
    flexDirection: 'row',
    backgroundColor: '#fff8f8',
    padding: 8,
    borderRadius: 6,
    marginBottom: 6,
    gap: 12,
    alignItems: 'center'
  },
    fieldRowGreen: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F4FEF4',
    padding: 8,
    borderRadius: 6,
    marginBottom: 6,
    gap: 10,
  },
  fieldRowGreenAlignStart: {
    flexDirection: 'row',
    backgroundColor: '#F4FEF4',
    padding: 8,
    borderRadius: 6,
    marginBottom: 6,
    gap: 12,
    alignItems: 'center'
  },
      fieldRowYellow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFF1D8',
    padding: 8,
    borderRadius: 6,
    marginBottom: 6,
    gap: 10,
  },
  fieldRowYellowAlignStart: {
    flexDirection: 'row',
    backgroundColor: '#FFF1D8',
    padding: 8,
    borderRadius: 6,
    marginBottom: 6,
    gap: 12,
    alignItems: 'center'
  },
  // Sivi stilovi za Bilješke
  bannerTitleGrey: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: '#A6A6A6', // Srednje siva
    color: '#FFFFFF',
    padding: 8,
    borderRadius: 8,
    marginBottom: 15,
    marginTop: 0,
  },
  instructionBoxGrey: {
    padding: 10,
    backgroundColor: '#F2F2F2',
    borderLeft: '5pt solid #A6A6A6',
    borderRadius: 5,
    marginBottom: 15,
  },
  instructionTextGrey: {
    fontSize: 11,
    color: '#545454',
    lineHeight: 1.4,
  },
  fieldRowGrey: {
    backgroundColor: '#f0f0f0',
    borderRadius: 10,
    padding: 20,
    flexDirection: 'column'
  },
  notesText: {
    fontSize: 12,
    color: '#333333',
    lineHeight: 1.6,
    textAlign: 'left', // Poravnato ulijevo za lakše čitanje duljeg teksta
  },
  finalSectionContainer: {
    marginTop: 30,
    borderTop: '1pt solid #f0f0f0',
    paddingTop: 20,
  },
  footerRow: {
    flexDirection: 'row',
    gap: 20,
    marginBottom: 30,
  },
  footerSubcol: {
    flex: 1,
  },
  iconLabelPair: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  footerIcon: {
    width: 50,
    height: 50,
  },
  footerLabel: { fontSize: 14, color: '#3b3b3b'
    
  },
  footerValue: {
    fontSize: 14, fontWeight: 'bold', color: '#000', 
    borderBottom: '1pt solid #C0C0C0',
    paddingBottom: 2,
    marginTop: 10,
    minHeight: 15,
  },
  projectInfoBox: {
    backgroundColor: '#f9f9f9',
    padding: 15,
    borderRadius: 8,
    marginTop: 20,
    border: '1pt solid #eeeeee',
  },
  logosContainer: {
  marginTop: 15,
  display: 'flex',
  flexDirection: 'column',
  gap: 12, // Razmak između prvog i drugog reda
  alignItems: 'center',
},
logoRow: {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between', // Širi ih ravnomjerno s lijeva na desno
  alignItems: 'center',
  width: '100%',
  paddingHorizontal: 10, // Da ne zalijepe skroz uz rubove sive kutije
},
pdfLogo: {
   
  width: 100,
  objectFit: 'contain',
},
  projectInfoTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 8,
    color: '#474747',
  },
  projectInfoText: {
    fontSize: 14,
    lineHeight: 1.5,
    color: '#474747',
    textAlign: 'left',
  },
  arasaacLogo: {
    width: 120,
    alignSelf: 'center',
    marginTop: 10,
    opacity: 0.8,
  },
  rowIcon: {
    width: 50,
    height: 50,
    objectFit: 'contain'
  },
  rowLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#333',
    width: 150
  },
  rowValue: {
    fontSize: 14,
    flex: 1, // Zauzima ostatak prostora
    color: '#000',
    marginLeft: 20
  },
  rowSubtitlePink: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#d63384',
    marginTop: 10,
    marginBottom: 5,
    marginLeft: 35, // Poravnato s tekstom nakon ikone
    textAlign: 'center'
  },
  bannerTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: '#facccc',
    padding: 10,
    borderRadius: 8,
    marginBottom: 15,
    marginTop: 5
  },
    bannerTitleGreen: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: '#B7ECB7',
    padding: 10,
    borderRadius: 8,
    marginBottom: 15,
    marginTop: 5
  },
  bannerTitleYellow: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: '#FFBC5E',
    padding: 5,
    borderRadius: 8,
    marginBottom: 15,
    marginTop: 5
  }
});


const MyPassportPDF = ({ data }) => (
  <Document>
    <Page size="A4" style={pdfStyles.page}>

       <View style={pdfStyles.headerBar} fixed>
        <Image
          style={{ height: 40, width: 80, objectFit: 'contain' }}
          src={"/komunikacijska-putovnica/icons/unicef-logo2.png"}
        />
      </View>

      <Text style={styles.naslov}>Komunikacijska putovnica</Text>
      <Text style={styles.podnaslov}>u slučaju hitnih situacija</Text>

      <View style={styles.introSection}>
        <View style={styles.introLeft}>
          {data.photo ? <Image style={styles.photoPreview} src={data.photo} /> : <View style={styles.photoPreview} />}
          <Text style={styles.imeTekst}>
            <Text style={{ fontWeight: 'bold' }}>Ime: </Text>
    {data.ime || '__________'}
            </Text>
        </View>
        
        <View style={styles.introRight}>
          <Text>Ova komunikacijska putovnica služi kao podrška zdravstvenim djelatnicima kako bi me bolje razumjeli - kako komunicirati sa mnom, kako mi pružiti odgovarajuću podršku te kako reagirati u stresnim ili zbunjujućim situacijama.</Text>
          <Text style={{ marginTop: 10, fontWeight: 'bold' }}>Nije zamjena za medicinsku dokumentaciju, već nadopuna koja doprinosi sigurnijem, empatičnijem i dostojanstvenijem pristupu skrbi.</Text>
        </View>
      </View>

      <View style={styles.overviewContainer}>
        <View style={[pdfStyles.sectionBanner, styles.pinkRow]}>
          <Image src="/komunikacijska-putovnica/icons/important.png" style={pdfStyles.bannerIcon} />
          <Text style={styles.sectionTitle}>VAŽNO O MENI</Text>
        </View>
        <View style={[pdfStyles.sectionBanner, styles.greenRow]}>
          <Image src="/komunikacijska-putovnica/icons/values.png" style={pdfStyles.bannerIcon} />
          <Text style={styles.sectionTitle}>STVARI KOJE SU MI VAŽNE</Text>
        </View>
        <View style={[pdfStyles.sectionBanner, styles.yellowRow]}>
          <Image src="/komunikacijska-putovnica/icons/volim.png" style={pdfStyles.bannerIcon} />
          <Text style={styles.sectionTitle}>VOLIM / NE VOLIM</Text>
        </View>
        
        
      </View>

      <View style={pdfStyles.footerContainer} fixed>
  {/* LIJEVA STRANA: Službeni potpis */}
  <Text style={pdfStyles.footerTextLeft}>
    © UNICEF-FER-ERF 2026. | Sva prava pridržana
  </Text>

  {/* DESNA STRANA: Stilski broj stranica */}
  <View style={pdfStyles.footerPageBox}>
    <Text 
      style={pdfStyles.footerPageText} 
      render={({ pageNumber, totalPages }) => (
        `${pageNumber} / ${totalPages}`
      )} 
    />
  </View>
</View>
    
    </Page>

    {/* STRANICA 2 - VAŽNO O MENI */}
    <Page size="A4" style={[pdfStyles.page, pdfStyles.pagePink]}>
      <View style={pdfStyles.headerBar} fixed>
        <Image style={{ height: 40, width: 80, objectFit: 'contain' }} src={"/komunikacijska-putovnica/icons/unicef-logo2.png"} />
      </View>

      <View style={pdfStyles.bannerTitle}>
        <Text>VAŽNO O MENI</Text>
      </View>


      <View style={pdfStyles.fieldRowPink}>
  <Image src="/komunikacijska-putovnica/icons/piktogram-ime.png" style={pdfStyles.rowIcon} />
  
  <View style={{ flexDirection: 'column', flex: 1, gap: 8 }}>
    {/* Red za Ime */}
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Ime i prezime:</Text>
      <Text style={pdfStyles.rowValue}>{data.punImePrezime || '/'}</Text>
    </View>
    
    {/* Red za Nadimak */}
    {data.nadimak && (
    <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
      <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Nadimak (kako me zovu moje bliske osobe):</Text>
      <Text style={pdfStyles.rowValue}>{data.nadimak || '/'}</Text>
    </View>
    )}
  </View>
</View>

<View style={pdfStyles.fieldRowPink}>
  <Image src="/komunikacijska-putovnica/icons/datum.png" style={pdfStyles.rowIcon} />
  
  <View style={{ flexDirection: 'column', flex: 1, gap: 8 }}>
    {/* Red za Datum */}
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Datum rođenja:</Text>
      
      <Text style={pdfStyles.rowValue}>{formatirajDatum(data.datumRodjenja)}</Text>
    </View>
    
    {/* Red za Spol */}
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Spol:</Text>
      <Text style={pdfStyles.rowValue}>{data.spol || '/'}</Text>
    </View>
  </View>
</View>


     <View style={pdfStyles.fieldRowPink}>
      
  <Image src="/komunikacijska-putovnica/icons/adresa.png" style={pdfStyles.rowIcon} />
  
  <View style={{ flexDirection: 'column', flex: 1, gap: 8 }}>
    
    <View style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
      <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Ime kontakt osobe:</Text>
      <Text style={pdfStyles.rowValue}>{data.kontaktOsoba || '/'}</Text>
    </View>
    
    
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Adresa:</Text>
      <Text style={pdfStyles.rowValue}>{data.adresa || '/'}</Text>
    </View>

    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Text style={pdfStyles.rowLabel}>Broj telefona:</Text>
      <Text style={[pdfStyles.rowValue, { width: 150 }]}>{data.telefon || '/'}</Text>
    </View>
  </View>
</View>

      

      {/* Komunikacija */}
      <View style={pdfStyles.fieldRowPinkAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/komunikacija.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Kako komuniciram/koji jezik govorim:</Text>
        <Text style={pdfStyles.rowValue}>{data.komunikacija || '/'}</Text>
      </View>

      {/* Podrška */}
      {data.podrska && (
      <View style={pdfStyles.fieldRowPinkAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/podrska.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Koji oblici podrške su mi potrebni i tko mi ih pruža:</Text>
        <Text style={pdfStyles.rowValue}>{data.podrska || '/'}</Text>
      </View>
      )}

      {/* Alergije */}
      {data.alergije && (
      <View style={pdfStyles.fieldRowPinkAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/alergije.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Alergije i intolerancije:</Text>
        <Text style={pdfStyles.rowValue}>{data.alergije || '/'}</Text>
      </View>
      )}

      
      {(data.teskoce || data.gusenje) && (
       <View style={pdfStyles.fieldRowPink} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/disanje.png" style={pdfStyles.rowIcon} />
        <View style={{ flexDirection: 'column', flex: 1, gap: 8 }}>
        
        {data.teskoce && (
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Teškoće sa srcem ili disanjem:</Text>
        <Text style={pdfStyles.rowValue}>{data.teskoce || '/'}</Text>
        </View>
        )}
      {data.gusenje && (
      <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
        <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Postoji li rizik od gušenja (teškoće sa gutanjem, hranjenjem):</Text>
        <Text style={pdfStyles.rowValue}>{data.gusenje || '/'}</Text>
      </View>
 )}
      </View>
    </View>
)}


      {data.usluge && (
      <View style={pdfStyles.fieldRowPinkAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/strucnjaci.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Koristim usluge drugih medicinskih i rehabilitacijskih stručnjaka:</Text>
        <Text style={pdfStyles.rowValue}>{data.usluge || '/'}</Text>
      </View>
      )}



      {data.prilagodba && (
      <View style={pdfStyles.fieldRowPinkAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/intervencije.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Na koji mi način treba prilagoditi medicinske postupke (na koji način izvaditi krv, dati injekciju, izmjeriti tlak…):</Text>
        <Text style={pdfStyles.rowValue}>{data.prilagodba || '/'}</Text>
      </View>
      )}

        {(data.lijekovi || data.uzimanjeLijekova) && (
       <View style={pdfStyles.fieldRowPink} wrap={false}>
  <Image src="/komunikacijska-putovnica/icons/lijekovi.png" style={pdfStyles.rowIcon} />
  
  <View style={{ flexDirection: 'column', flex: 1, gap: 8 }}>
    {data.lijekovi && (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Trenutno koristim lijekove:</Text>
      <Text style={pdfStyles.rowValue}>{data.lijekovi || '/'}</Text>
    </View>
    )}
   
    {data.uzimanjeLijekova && (
    <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
      <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Kako najlakše uzimam lijekove (smrvljene, sa sokom, injekcija...):</Text>
      <Text style={pdfStyles.rowValue}>{data.uzimanjeLijekova || '/'}</Text>
    </View>
    )}
  </View>
</View>
)}

      {data.medicinskaPovijest && (
      <View style={pdfStyles.fieldRowPinkAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/povijest.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Moja medicinska povijest i plan liječenja:</Text>
        <Text style={pdfStyles.rowValue}>{data.medicinskaPovijest || '/'}</Text>
      </View>
      )}

  {data.strah && (
      <View style={pdfStyles.fieldRowPinkAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/strah.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Što činim ako me strah i kako mi možeš pomoći:</Text>
        <Text style={pdfStyles.rowValue}>{data.strah || '/'}</Text>
      </View>
      )}
      
    
      <View style={pdfStyles.footerContainer} fixed>
  {/* LIJEVA STRANA: Službeni potpis */}
  <Text style={pdfStyles.footerTextLeft}>
    © UNICEF-FER-ERF 2026. | Sva prava pridržana
  </Text>

  {/* DESNA STRANA: Stilski broj stranica */}
  <View style={pdfStyles.footerPageBox}>
    <Text 
      style={pdfStyles.footerPageText} 
      render={({ pageNumber, totalPages }) => (
        `${pageNumber} / ${totalPages}`
      )} 
    />
  </View>
</View>
    </Page>


    {/* STRANICA 3 - STVARI KOJE SU MI VAŽNE */}
    <Page size="A4" style={[pdfStyles.page, pdfStyles.pageGreen]}>
      <View style={pdfStyles.headerBar} fixed>
        <Image style={{ height: 40, width: 80, objectFit: 'contain' }} src={"/komunikacijska-putovnica/icons/unicef-logo2.png"} />
      </View>

      <View style={pdfStyles.bannerTitleGreen}>
        <Text>STVARI KOJE SU MI VAŽNE</Text>
      </View>
  

      {/* Laka komunikacija */}
      <View style={pdfStyles.fieldRowGreenAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/komunicirati.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Najlakše komuniciram ako:</Text>
        <Text style={pdfStyles.rowValue}>{data.lakaKomunikacija || '/'}</Text>
      </View>

      {/* Bol */}
      <View style={pdfStyles.fieldRowGreenAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/bol.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Kako dajem do znanja da me boli:</Text>
        <Text style={pdfStyles.rowValue}>{data.bol || '/'}</Text>
      </View>


      {/* Kretanje */}
      {data.kretanje && (
      <View style={pdfStyles.fieldRowGreenAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/hodalica.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Kako me pozicionirati i kako se krećem:</Text>
        <Text style={pdfStyles.rowValue}>{data.kretanje || '/'}</Text>
      </View>
      )}

      {/* Osjetila */}
      {data.osjetila && (
      <View style={pdfStyles.fieldRowGreenAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/slusati.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Stanje mog sluha i vida:</Text>
        <Text style={pdfStyles.rowValue}>{data.osjetila || '/'}</Text>
      </View>
      )}

      {/* Pomagala */}
      {data.pomagala && (
      <View style={pdfStyles.fieldRowGreenAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/pomagala.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Koristim pomagala:</Text>
        <Text style={pdfStyles.rowValue}>{data.pomagala || '/'}</Text>
      </View>
      )}

      {/* Jedem i pijem */}
       {(data.jedem || data.pijem) && (
       <View style={pdfStyles.fieldRowGreen} wrap={false}>
      <Image src="/komunikacijska-putovnica/icons/jedem.png" style={pdfStyles.rowIcon} />
  
      <View style={{ flexDirection: 'column', flex: 1, gap: 8 }}>

      {data.jedem && (
       <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Kako jedem:</Text>
          <Text style={pdfStyles.rowValue}>{data.jedem || '/'}</Text>
       </View>
    )}
    {data.pijem && (
    <View style={{ flexDirection: 'row', marginTop: 5, alignItems: 'center' }}>
      <Text style={[pdfStyles.rowLabel, { width: 150 }]}>Kako pijem:</Text>
      <Text style={pdfStyles.rowValue}>{data.pijem || '/'}</Text>
    </View>
    )}
    </View>
  </View>

  )}

      {data.spavanje && (
      <View style={pdfStyles.fieldRowGreenAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/spavanje.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Moj ritam spavanja:</Text>
        <Text style={pdfStyles.rowValue}>{data.spavanje || '/'}</Text>
      </View>
      )}



      {data.nuzda && (
      <View style={pdfStyles.fieldRowGreenAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/toalet.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Nuždu obavljam:</Text>
        <Text style={pdfStyles.rowValue}>{data.nuzda || '/'}</Text>
      </View>
      )}

        {data.higijena && (
      <View style={pdfStyles.fieldRowGreenAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/pasta.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Kako obavljam osobnu higijenu:</Text>
        <Text style={pdfStyles.rowValue}>{data.higijena || '/'}</Text>
      </View>
      )}


      {data.sigurnost && (
      <View style={pdfStyles.fieldRowGreenAlignStart} wrap={false}>
        <Image src="/komunikacijska-putovnica/icons/sigurnost.png" style={pdfStyles.rowIcon} />
        <Text style={[pdfStyles.rowLabel, { width: 135 }]}>Pazite na moju sigurnost:</Text>
        <Text style={pdfStyles.rowValue}>{data.sigurnost || '/'}</Text>
      </View>
      )}

     
       <View style={pdfStyles.footerContainer} fixed>
  {/* LIJEVA STRANA: Službeni potpis */}
  <Text style={pdfStyles.footerTextLeft}>
    © UNICEF-FER-ERF 2026. | Sva prava pridržana
  </Text>

  {/* DESNA STRANA: Stilski broj stranica */}
  <View style={pdfStyles.footerPageBox}>
    <Text 
      style={pdfStyles.footerPageText} 
      render={({ pageNumber, totalPages }) => (
        `${pageNumber} / ${totalPages}`
      )} 
    />
  </View>
</View>
    </Page>


    {/* SEKCIJA 3 - VOLIM / NE VOLIM */}
    {( (data.volim && data.volim.trim() !== "") || 
   (data.neVolim && data.neVolim.trim() !== "") || 
   data.photoVolim || 
   data.photoNeVolim 
) && (
    <Page size="A4" style={[pdfStyles.page, pdfStyles.pageYellow]}>
      <View style={pdfStyles.headerBar} fixed>
        <Image style={{ height: 40, width: 80, objectFit: 'contain' }} src={"/komunikacijska-putovnica/icons/unicef-logo2.png"} />
      </View>

    

      {/* SEKCIJA 3 - VOLIM / NE VOLIM */}

   <View style={pdfStyles.bannerTitleYellow}>
        <Text>VOLIM / NE VOLIM</Text>
      </View>

  {/* --- BLOK: VOLIM --- */}
  {(data.volim?.trim() !== "" || data.photoVolim) && (
  <View style={[pdfStyles.fieldRowYellow, { 
    flexDirection: 'column', 
    alignItems: 'center', 
    padding: 15, 
    backgroundColor: '#FFF1D8', 
    borderRadius: 10,
    marginBottom: 15 
  }]} wrap={false}>
    
    {/* Prvi podred: Ikona i Naslov */}
    <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: 10 }}>
      <Image src="/komunikacijska-putovnica/icons/volim.png" style={{ width: 35, height: 35, marginRight: 10 }} />
      <Text style={{ fontSize: 14, fontWeight: 'bold', color: '#333' }}>
        Stvari koje volim (molim postupiti):
      </Text>
    </View>

    {/* Drugi podred: Tekstualni unos */}
    <Text style={{ 
      fontSize: 14, 
      textAlign: 'left', 
      marginBottom: 15, 
      width: '90%', 
      lineHeight: 1.4 
    }}>
      {data.volim}
    </Text>

    {/* Treći podred: Slika */}
    {data.photoVolim && (
      <Image 
        src={data.photoVolim} 
        style={{ 
          width: 130, 
          height: 130, 
          borderRadius: 8, 
          objectFit: 'cover', 
          border: '2pt solid #FFFFFF' 
        }} 
      />
    )}
  </View>
  )}

  {/* --- BLOK: NE VOLIM --- */}
  {(data.neVolim?.trim() !== "" || data.photoNeVolim) && (
  <View style={[pdfStyles.fieldRowYellow, { 
    flexDirection: 'column', 
    alignItems: 'center', 
    padding: 15, 
    backgroundColor: '#FFF1D8', 
    borderRadius: 10 
  }]} wrap={false}>
    
    {/* Prvi podred: Ikona i Naslov */}
    <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: 10 }}>
      <Image src="/komunikacijska-putovnica/icons/ne-volim.png" style={{ width: 35, height: 35, marginRight: 10 }} />
      <Text style={{ fontSize: 14, fontWeight: 'bold', color: '#333' }}>
        Stvari koje ne volim (nikako nemojte):
      </Text>
    </View>

    {/* Drugi podred: Tekstualni unos */}
    <Text style={{ 
      fontSize: 14, 
      textAlign: 'left', 
      marginBottom: 15, 
      width: '90%', 
      lineHeight: 1.4 
    }}>
      {data.neVolim}
    </Text>

    {/* Treći podred: Slika */}
    {data.photoNeVolim && (
      <Image 
        src={data.photoNeVolim} 
        style={{ 
          width: 130, 
          height: 130, 
          borderRadius: 8, 
          objectFit: 'cover', 
          border: '2pt solid #FFFFFF' 
        }} 
      />
    )}
  </View>
  )}




      <View style={pdfStyles.footerContainer} fixed>
  {/* LIJEVA STRANA: Službeni potpis */}
  <Text style={pdfStyles.footerTextLeft}>
    © UNICEF-FER-ERF 2026. | Sva prava pridržana
  </Text>

  {/* DESNA STRANA: Stilski broj stranica */}
  <View style={pdfStyles.footerPageBox}>
    <Text 
      style={pdfStyles.footerPageText} 
      render={({ pageNumber, totalPages }) => (
        `${pageNumber} / ${totalPages}`
      )} 
    />
  </View>
</View>
  
 </Page>
 )}

 {/* STRANICA 4 - BILJEŠKE */}
 
<Page size="A4" style={pdfStyles.page}>
  {/* Header s logotipom */}
  <View style={pdfStyles.headerBar}>
    <Image 
      style={{ height: 40, width: 80, objectFit: 'contain' }} 
      src={"/komunikacijska-putovnica/icons/unicef-logo2.png"} 
    />
  </View>

  {data.biljeske && data.biljeske.trim().length > 0 && (
  <View style={{ marginBottom: 40 }}>
  {/* Sivi Banner Naslov */}
  <View style={pdfStyles.bannerTitleGrey}>
    <Text>BILJEŠKE</Text>
  </View>



  {/* Glavni kontejner za bilješke */}
  <View style={pdfStyles.fieldRowGrey}>
    <Text style={pdfStyles.notesText}>
      {data.biljeske || 'Nema dodatnih bilješki.'}
    </Text>
  </View>
  </View>
)}


 <View style={pdfStyles.footerContainer} fixed>
  {/* LIJEVA STRANA: Službeni potpis */}
  <Text style={pdfStyles.footerTextLeft}>
    © UNICEF-FER-ERF 2026. | Sva prava pridržana
  </Text>

  {/* DESNA STRANA: Stilski broj stranica */}
  <View style={pdfStyles.footerPageBox}>
    <Text 
      style={pdfStyles.footerPageText} 
      render={({ pageNumber, totalPages }) => (
        `${pageNumber} / ${totalPages}`
      )} 
    />
  </View>
</View>


<View style={pdfStyles.finalSectionContainer}>
  
  {/* RED S POTPISOM I DATUMOM */}
  <View style={pdfStyles.footerRow}>
    
    {/* Podatke unio */}
    <View style={pdfStyles.footerSubcol}>
      <View style={pdfStyles.iconLabelPair}>
        <Image src="/komunikacijska-putovnica/icons/potpisati.png" style={pdfStyles.footerIcon} />
        <View style={{ flex: 1 }}>
          <Text style={pdfStyles.footerLabel}>Podatke unio:</Text>
          <Text style={pdfStyles.footerValue}>{data.podatkeUnio || ' '}</Text>
        </View>
      </View>
    </View>

    {/* Datum */}
    <View style={pdfStyles.footerSubcol}>
      <View style={pdfStyles.iconLabelPair}>
        <Image src="/komunikacijska-putovnica/icons/kalendar.png" style={pdfStyles.footerIcon} />
        <View style={{ flex: 1 }}>
          <Text style={pdfStyles.footerLabel}>Datum:</Text>
          <Text style={pdfStyles.footerValue}>
            {data.datumUnosa ? new Date(data.datumUnosa).toLocaleDateString('hr-HR') : ' '}
          </Text>
        </View>
      </View>
    </View>

  </View>

  {/* INFORMACIJE O PROJEKTU */}
  <View style={pdfStyles.projectInfoBox}>
     <Text style={pdfStyles.projectInfoText}>
      Ovaj materijal nastao je u okviru programa{" "} 
      <Text style={{ fontStyle: 'italic' }}>
      „Komunikacija za svako dijete – unaprjeđenje komunikacije zdravstvenih djelatnika s ranjivim skupinama djece primjenom potpomognute komunikacije i digitalne tehnologije“
  </Text>, financiranog od strane Ureda UNICEF-a za Hrvatsku putem donacija građana i tvrtki. {"\n"}
  Komunikacijska putovnica izrađena je po uzoru na materijal 
  <Text style={{ fontStyle: 'italic' }}> Komunikacijska putovnica Widgit Symbols</Text> te sadrži ARASAAC piktograme (autor: Sergio Palao), dostupne pod licencom CC BY-NC-SA. Vlasnik resursa ARASAAC je Vlada autonomne zajednice Aragonije, Španjolska.
    </Text>
    <View style={pdfStyles.logosContainer}>
    
    <View style={pdfStyles.logoRow}>
      <Image src="/komunikacijska-putovnica/icons/arasaac-logo.png" style={pdfStyles.pdfLogo} />
      <Image src="/komunikacijska-putovnica/icons/logo1.png" style={pdfStyles.pdfLogo} />
      <Image src="/komunikacijska-putovnica/icons/logo2.png" style={pdfStyles.pdfLogo} />
      <Image src="/komunikacijska-putovnica/icons/logo3.png" style={pdfStyles.pdfLogo} />
    </View>

    <View style={pdfStyles.logoRow}>
      <Image src="/komunikacijska-putovnica/icons/logo4.png" style={pdfStyles.pdfLogo} />
      <Image src="/komunikacijska-putovnica/icons/logo5.png" style={pdfStyles.pdfLogo} />
      <Image src="/komunikacijska-putovnica/icons/logo6.png" style={pdfStyles.pdfLogo} />
      <Image src="/komunikacijska-putovnica/icons/logo7.png" style={pdfStyles.pdfLogo} />
    </View>

  </View>
    
  </View>

</View>
</Page>

  </Document>
);

export default function App() {
  const pinkRef = useRef(null);
const greenRef = useRef(null);
const yellowRef = useRef(null);



  const [formData, setFormData] = useState({
  // Prva stranica
  ime: '', 
  photo: null,
  // Prva sekcija (VAŽNO O MENI)
  punImePrezime: '',
  nadimak: '',
  datumRodjenja: '',
  spol: '',
  kontaktOsoba: '',
  adresa: '',
  telefon: '',
  komunikacija: '',
  podrska: '',
  alergije: '',
  teskoce: '',
  gusenje: '',
  usluge: '',
  prilagodba: '',
  lijekovi: '',
  uzimanjeLijekova: '',
  medicinskaPovijest: '',
  strah: '',
  // Druga sekcija (STVARI KOJE SU MI VAŽNE)
  lakaKomunikacija: '',
  bol: '',
  kretanje: '',
  osjetila: '',
  pomagala: '',
  jedem: '',
  pijem: '',
  spavanje: '',
  nuzda: '',
  higijena: '',
  sigurnost: '',
  // Treća sekcija (VOLIM/NE VOLIM)
  volim: '',
  photoVolim: null,
  neVolim: '',
  photoNeVolim: null,
  biljeske: '',
  podatkeUnio: '',
  datumUnosa: new Date().toISOString().split('T')[0]
});
  const [isReady, setIsReady] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const piktogrami = [
    'komunikacijska-putovnica/icons/piktogrami/boy1.png', 'komunikacijska-putovnica/icons/piktogrami/boy2.png', 'komunikacijska-putovnica/icons/piktogrami/boy3.png', 
    'komunikacijska-putovnica/icons/piktogrami/boy4.png', 'komunikacijska-putovnica/icons/piktogrami/boy5.png', 'komunikacijska-putovnica/icons/piktogrami/boy6.png', 
    'komunikacijska-putovnica/icons/piktogrami/boy7.png', 'komunikacijska-putovnica/icons/piktogrami/boy8.png', 'komunikacijska-putovnica/icons/piktogrami/boy9.png', 
    'komunikacijska-putovnica/icons/piktogrami/girl1.png', 'komunikacijska-putovnica/icons/piktogrami/girl2.png', 'komunikacijska-putovnica/icons/piktogrami/girl3.png', 
    'komunikacijska-putovnica/icons/piktogrami/girl4.png', 'komunikacijska-putovnica/icons/piktogrami/girl5.png', 'komunikacijska-putovnica/icons/piktogrami/girl7.png', 
    'komunikacijska-putovnica/icons/piktogrami/girl8.png', 'komunikacijska-putovnica/icons/piktogrami/girl9.png'
  ];

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
    let finalFile = file;

    // 1. Provjeri je li slika HEIC
    if (file.type === "" || file.name.toLowerCase().endsWith('.heic')) {
      const conversionResult = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.7, // Balans između kvalitete i veličine
      });
      
      // Pretvaramo rezultat u File objekt
      finalFile = new File([conversionResult], file.name.split('.')[0] + ".jpg", {
        type: "image/jpeg",
      });
    }

    const reader = new FileReader();

    reader.onload = (event) => {
    const img = new window.Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;

      const MAX_SIDE = 1200;
      if (width > height) {
        if (width > MAX_SIDE) {
          height *= MAX_SIDE / width;
          width = MAX_SIDE;
        }
      } else {
        if (height > MAX_SIDE) {
          width *= MAX_SIDE / height;
          height = MAX_SIDE;
        }
      }

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      const compressedDataUrl = canvas.toDataURL('image/jpeg', 0.7);
      
      setFormData(prev => ({ ...prev, photo: compressedDataUrl }));
      setSelectedPhoto(null);
        setError(false); // Resetiraj grešku
        setIsReady(false);
    };
    img.src = event.target.result;
  };
   
      reader.readAsDataURL(finalFile);

  } catch (error) {
    console.error("Greška pri pretvorbi HEIC slike:", error);
  }
    
  };

const handleSubImageUpload = async (e, targetField) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    let fileToProcess = file;

    // Provjera: ako je HEIC, pretvori ga u JPEG
    if (file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif')) {
      const conversionResult = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.8,
      });
      // Stvaramo novi file objekt od konvertiranog rezultata
      fileToProcess = new File([conversionResult], file.name.split('.')[0] + ".jpg", {
        type: "image/jpeg",
      });
    }

    // Čitanje slike (bilo da je bila originalni JPG ili konvertirani HEIC)
    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData(prev => ({ ...prev, [targetField]: reader.result }));
      if (typeof setIsReady === "function") setIsReady(false);
    };
    reader.readAsDataURL(fileToProcess);

  } catch (error) {
    console.error("Greška pri obradi slike:", error);
    alert("Došlo je do greške pri učitavanju slike. Pokušajte drugu datoteku.");
  }
};

    


const handlePiktogramSelect = (putanja) => {
  setSelectedPhoto(putanja);
  setFormData({ ...formData, photo: `${baseUrl}/${putanja}` });
  setError(false); 
  setIsReady(false);
};


const handleGenerate = () => {
  // Provjera
  if (!formData.ime.trim() || !formData.photo || !formData.punImePrezime || !formData.datumRodjenja || !formData.spol || !formData.kontaktOsoba || !formData.adresa || !formData.telefon || !formData.komunikacija || !formData.lakaKomunikacija || !formData.bol || !formData.pomagala) {
    setError(true);
    setErrorMsg('U obrascu niste popunili neka od obaveznih polja.');
    setIsReady(false);
    return;
  }
  setError(false);
  setErrorMsg('');
  setIsReady(true);
};


const handleChange = (e) => {
  const { name, value } = e.target; 
  setFormData(prev => ({ 
    ...prev,
    [name]: value // Dinamički ažurira točno to polje u stateu
  }));
  if (value.trim() !== "") {
    setError(prev => {
      const newErrors = { ...prev };
      delete newErrors[name]; 
      return newErrors;
    });
  }
  //setError(false);
  setIsReady(false);
};

const handlePhoneChange = (e) => {
  const cleanedValue = e.target.value.replace(/\D/g, ''); 
  setFormData(prev => ({ ...prev, telefon: cleanedValue }));
};

const isPhoneInvalid = (phone) => {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length > 0 && cleaned.length < 9; 
};

const today = new Date().toISOString().split('T')[0];
  

  return (
    <div className="app-container">
      <div className="web-a4-paper">
        <div className="web-header-bar">
          <img src={unicefLogo} alt="UNICEF Logo" className="web-header-logo" />
        </div>

        <h1 className="web-title">Komunikacijska putovnica</h1>
        <h2 className="web-subtitle">u slučaju hitnih situacija</h2>

        <div className="web-intro-section">
          <div className="web-intro-left">

            <div className="photo-preview-web" 
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#999', backgroundColor: '#ddd', border: (error && !formData.photo) ? '3px solid #d32f2f' : '3px solid white'}}
            >

            {formData.photo ? (
              <img key={formData.photo} src={formData.photo} alt="Preview" style={{ width: '100%', height: '100%', borderRadius: '5px', objectFit: 'cover' }} />
            ) : (
              <span style={{ padding: '10px', display: 'block', color: error ? '#d32f2f' : '#666' }}
              >{error ? "Odaberite piktogram ili učitajte fotografiju! Podržani formati: JPG, PNG." : "Nema slike. Podržani formati: JPG, PNG."}</span>
            )}
      
            </div>
      
<div style={{ width: '100%', marginTop: '10px' }}>
    <label style={{ marginLeft: '10px', fontWeight: 'bold', display: 'block', color: (error && !formData.ime.trim()) ? '#d32f2f' : '#333' }}>
      Ime: {(error && !formData.ime.trim()) && <span style={{ fontSize: '12px' }}>(Obavezno polje)</span>}
    </label>
    <input 
      type="text" name="ime"
      placeholder="Upišite ime..."
      maxLength="40"
      value={formData.ime}
      style={{ 
        marginLeft: '10px', width: '90%', 
        padding: '12px', 
        marginTop: '5px', 
        border: (error && !formData.ime.trim()) ? '2px solid #d32f2f' : '1px solid #ccc', 
        borderRadius: '5px', 
        outline: 'none' 
      }} 
      onChange={handleChange}
    />
  </div>

            <div className="upload-controls" style={{ marginTop: '20px' }}>
              <label className="upload-btn-label">
                📁 Učitaj fotografiju
                <input type="file" onChange={handleImageUpload} style={{ display: 'none' }} accept="image/*" />
              </label>

              <p style={{ margin: '5px 0', fontSize: '14px' }}>Ili odaberite piktogram:</p>
              <div className="piktogram-grid">
                {piktogrami.map((p) => (
                  <img
                    key={p}
                    src={`${baseUrl}/${p}`}
                    alt="piktogram"
               
                    className={`piktogram-thumb ${selectedPhoto === p ? 'selected' : ''}`}
                    onClick={() => handlePiktogramSelect(p)}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="web-intro-right">
            <p style={{ marginTop: 0 }}>Ova komunikacijska putovnica služi kao podrška zdravstvenim djelatnicima kako bi me bolje razumjeli - <i>kako komunicirati sa mnom, kako mi pružiti odgovarajuću podršku te kako reagirati u stresnim ili zbunjujućim situacijama</i>.</p>
            <p><b>Nije zamjena za medicinsku dokumentaciju</b>, već nadopuna koja doprinosi sigurnijem, empatičnijem i dostojanstvenijem pristupu skrbi.</p>
          </div>
        </div>

        
        <div className="section-banner banner-pink" style={{ cursor: 'pointer' }} onClick={() => pinkRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <img src="/komunikacijska-putovnica/icons/important.png" alt="icon" className="banner-icon" />
          <span>VAŽNO O MENI</span>
        </div>
        <div className="section-banner banner-green" style={{ cursor: 'pointer' }} 
     onClick={() => greenRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <img src="/komunikacijska-putovnica/icons/values.png" alt="icon" className="banner-icon" />
          <span>STVARI KOJE SU MI VAŽNE</span>
        </div>

        <div className="section-banner banner-yellow" style={{ cursor: 'pointer' }} 
     onClick={() => yellowRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <img src="/komunikacijska-putovnica/icons/volim.png" alt="icon" className="banner-icon" />
          <span>VOLIM / NE VOLIM</span>
        </div>



        {/* Sekcija 2: VAŽNO O MENI */}
<div className="section-banner-title banner-pink" ref={pinkRef} style={{ marginTop: '30px' }}>VAŽNO O MENI</div>

<div className="form-container-pink">
  

  <div className="field-row-pink">
  <img src="/komunikacijska-putovnica/icons/piktogram-ime.png" alt="O meni" className="row-icon" />
  
    <div className="row-column">
    
      <div className="row-sub-field">
        <label className="row-label-small" style={{ display: 'block', color: (error && !formData.punImePrezime.trim()) ? '#d32f2f' : '#333' 
                }}>Ime i prezime: {(error && !formData.punImePrezime.trim()) && <span style={{ fontSize: '12px' }}> (Obavezno polje)</span>}</label>
          <input 
            name="punImePrezime" maxLength="40" value={formData.punImePrezime} placeholder="npr. Anto Antić (obavezno)" className="row-input"
            style={{ 
           border: (error && !formData.punImePrezime.trim()) ? '2px solid #d32f2f' : '1px solid #facccc', 
        }} onChange={handleChange} 
         />
      </div>


    <div className="row-sub-field">
      <label className="row-label-small">Nadimak (kako me zovu moje bliske osobe):</label>
      <input 
        name="nadimak" maxLength="20"
        value={formData.nadimak} 
        placeholder="npr. Antiša" 
        className="row-input" 
        onChange={handleChange} 
      />
    </div>
  </div>
</div>

  <div className="field-row-pink">
  <img src="/komunikacijska-putovnica/icons/datum.png" alt="Datum" className="row-icon" />
  
    <div className="row-column">
    
    <div className="row-sub-field">
        <label className="row-label-small" style={{ display: 'block', color: (error && !formData.datumRodjenja.trim()) ? '#d32f2f' : '#333' 
                }}>Datum rođenja:{(error && !formData.datumRodjenja) && <span style={{ fontSize: '12px' }}> (Obavezno polje, upišite samostalno ili odaberite datum u kalendaru)</span>}</label>
          <input name="datumRodjenja" type="date" max={today} className="row-input" value={formData.datumRodjenja}
    style={{ 
      border: (error && !formData.datumRodjenja.trim()) ? '2px solid #d32f2f' : '1px solid #facccc', 
    }} onChange={handleChange} />
      </div>


    <div className="row-sub-field">
      <label className="row-label-small" style={{ display: 'block', color: (error && !formData.spol.trim()) ? '#d32f2f' : '#333' 
                }}>Spol:{(error && !formData.spol) && <span style={{ fontSize: '12px' }}> (Obavezno polje)</span>} </label>
      <select name="spol" className="row-input" style={{ 
           border: (error && !formData.spol.trim()) ? '2px solid #d32f2f' : '1px solid #facccc', 
        }} onChange={handleChange}>
      <option value="">Odaberite spol</option>
      <option value="Muško">Muško</option>
      <option value="Žensko">Žensko</option>
    </select>
    </div>
  </div>
</div>


    <div className="field-row-pink">
       
      
  <img src="/komunikacijska-putovnica/icons/adresa.png" alt="Kontakt" className="row-icon" />
  
    <div className="row-column">
    
      <div className="row-sub-field">
        <label className="row-label-small" style={{ display: 'block', color: (error && !formData.kontaktOsoba.trim()) ? '#d32f2f' : '#333' 
                }}>Ime kontakt osobe:{(error && !formData.kontaktOsoba) && <span style={{ fontSize: '12px' }}> (Obavezno polje)</span>}</label>
          <input name="kontaktOsoba" maxLength="40" placeholder="npr. Ana (baka)" className="row-input" style={{ 
           border: (error && !formData.kontaktOsoba.trim()) ? '2px solid #d32f2f' : '1px solid #facccc', 
        }} onChange={handleChange} />
      </div>

    <div className="row-sub-field">
      <label className="row-label-small" style={{ display: 'block', color: (error && !formData.adresa.trim()) ? '#d32f2f' : '#333' 
                }}>Adresa:{(error && !formData.adresa) && <span style={{ fontSize: '12px' }}> (Obavezno polje)</span>} </label>
      <input name="adresa" maxLength="60" placeholder="Ulica, kućni broj, grad" className="row-input" style={{ 
           border: (error && !formData.adresa.trim()) ? '2px solid #d32f2f' : '1px solid #facccc', 
        }} onChange={handleChange} />
  </div>

<div className="row-sub-field">
  <label 
    className="row-label-small" 
    style={{ 
      display: 'block', 
      color: (error && !formData.telefon.trim()) || isPhoneInvalid(formData.telefon) ? '#d32f2f' : '#333' 
    }}
  >
    Broj telefona: 
    {/* Prikazuje "Obavezno" ako je prazno, ili "Broj je prekratak" ako je format kriv */}
    {(error && !formData.telefon.trim()) && <span style={{ fontSize: '12px' }}> (Obavezno polje)</span>}
    {isPhoneInvalid(formData.telefon) && <span style={{ fontSize: '12px' }}> (Format nije ispravan)</span>}
  </label>
  
  <input 
    name="telefon" 
    type="tel" 
    maxLength="15" 
    placeholder="npr. 0911234567" 
    className="row-input" 
    value={formData.telefon}
    onChange={handlePhoneChange}
    onKeyDown={(e) => {
      // OVDJE BLOKIRAMO SLOVA
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
      if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
        e.preventDefault();
      }
    }}
    style={{ 
      border: ((error && !formData.telefon.trim()) || isPhoneInvalid(formData.telefon)) 
              ? '2px solid #d32f2f' 
              : '1px solid #facccc', 
    }} 
  />
</div>

    </div>
  </div>


  {/* Komunikacija */}
  <div className="field-row-pink align-start">
    <img src="/komunikacijska-putovnica/icons/komunikacija.png" alt="Komunikacija" className="row-icon" />
    <div className="content-wrapper">
    <label className="row-label-small" style={{ display: 'block', color: (error && !formData.komunikacija.trim()) ? '#d32f2f' : '#333' 
                }}>Kako komuniciram/koji jezik govorim:{(error && !formData.komunikacija) && <span style={{ fontSize: '12px' }}> (Obavezno polje)</span>} </label>
    <div className="input-with-counter">
      <textarea name="komunikacija" maxLength="200" placeholder="Npr. koristim komunikacijsku knjigu, hrvatski jezik..." className="row-input" style={{ 
           border: (error && !formData.komunikacija.trim()) ? '2px solid #d32f2f' : '1px solid #facccc', 
        }} rows="3" onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.komunikacija.length >= 190 ? 'char-counter-limit' : ''}`}>
        {formData.komunikacija.length} / 200
      </span>
    </div>
    </div>
  </div>

  {/* Podrška */}
  <div className="field-row-pink align-start">
    <img src="/komunikacijska-putovnica/icons/podrska.png" alt="Podrška" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Koji oblici podrške su mi potrebni i tko mi ih pruža:</label>
    <div className="input-with-counter">
      <textarea name="podrska" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.podrska.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.podrska.length} / 250 
      </span>
    </div>
    </div>
  </div>

  <div className="field-row-pink align-start">
    <img src="/komunikacijska-putovnica/icons/alergije.png" alt="Alergije" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Alergije i intolerancije:</label>
    <div className="input-with-counter">
      <textarea name="alergije" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.alergije.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.alergije.length} / 250 
      </span>
    </div>
    </div>
  </div>

  <div className="field-row-pink">
  <img src="/komunikacijska-putovnica/icons/disanje.png" alt="Teškoće i rizici" className="row-icon" />
   <div className="content-wrapper">
    <div className="row-column">
    
      <div className="row-sub-field">
       
        <label className="row-label-small">Teškoće sa srcem ili disanjem: </label>
          <div className="input-with-counter">
            <textarea name="teskoce" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" onChange={handleChange}></textarea>
              <span className={`char-counter ${formData.teskoce.length >= 240 ? 'char-counter-limit' : ''}`}>
                {formData.teskoce.length} / 250 
              </span>
         </div>
          
      </div>


    <div className="row-sub-field">
      <label className="row-label-small">Postoji li rizik od gušenja <span style={{ fontWeight: 'normal' }}> (teškoće s gutanjem, hranjenjem)</span>:</label>
      <div className="input-with-counter">
            <textarea name="gusenje" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" onChange={handleChange}></textarea>
              <span className={`char-counter ${formData.gusenje.length >= 240 ? 'char-counter-limit' : ''}`}>
                {formData.gusenje.length} / 250 
              </span>
         </div>
    </div>
  </div>
  </div>
</div>

 <div className="field-row-pink align-start">
    <img src="/komunikacijska-putovnica/icons/strucnjaci.png" alt="Usluge" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Koristim usluge drugih medicinskih i rehabilitacijskih stručnjaka:</label>
    <div className="input-with-counter">
      <textarea name="usluge" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.usluge.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.usluge.length} / 250 
      </span>
    </div>
    </div>
  </div>

   <div className="field-row-pink align-start">
    <img src="/komunikacijska-putovnica/icons/intervencije.png" alt="Prilagodba" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Na koji mi način treba prilagoditi medicinske postupke <span style={{ fontWeight: 'normal' }}> (na koji način izvaditi krv, dati injekciju, izmjeriti tlak…)</span>:</label>
    <div className="input-with-counter">
      <textarea name="prilagodba" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.prilagodba.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.prilagodba.length} / 250 
      </span>
    </div>
    </div>
  </div>

  <div className="field-row-pink">
  <img src="/komunikacijska-putovnica/icons/lijekovi.png" alt="Lijekovi" className="row-icon" />
  <div className="content-wrapper">
    <div className="row-column">
    
      <div className="row-sub-field">
        <label className="row-label-small">Trenutno koristim lijekove: </label>
          <div className="input-with-counter">
            <textarea name="lijekovi" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" onChange={handleChange}></textarea>
              <span className={`char-counter ${formData.lijekovi.length >= 240 ? 'char-counter-limit' : ''}`}>
                {formData.lijekovi.length} / 250 
              </span>
         </div>
          
      </div>


    <div className="row-sub-field">
      <label className="row-label-small">Kako najlakše uzimam lijekove <span style={{ fontWeight: 'normal' }}> (smrvljene, sa sokom, injekcija...)</span>:</label>
      <div className="input-with-counter">
            <textarea name="uzimanjeLijekova" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" onChange={handleChange}></textarea>
              <span className={`char-counter ${formData.uzimanjeLijekova.length >= 240 ? 'char-counter-limit' : ''}`}>
                {formData.uzimanjeLijekova.length} / 250 
              </span>
         </div>
    </div>
  </div>
  </div>
</div>

 <div className="field-row-pink align-start">
    <img src="/komunikacijska-putovnica/icons/povijest.png" alt="Medicinska povijest" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Moja medicinska povijest i plan liječenja:</label>
    <div className="input-with-counter">
      <textarea name="medicinskaPovijest" maxLength="450" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="6" onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.medicinskaPovijest.length >= 440 ? 'char-counter-limit' : ''}`}>
        {formData.medicinskaPovijest.length} / 450 
      </span>
    </div>
    </div>
  </div>

   <div className="field-row-pink align-start">
    <img src="/komunikacijska-putovnica/icons/strah.png" alt="Strah" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Što činim ako me strah i kako mi možeš pomoći:</label>
    <div className="input-with-counter">
      <textarea name="strah" maxLength="450" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="6" onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.strah.length >= 440 ? 'char-counter-limit' : ''}`}>
        {formData.strah.length} / 450 
      </span>
    </div>
    </div>
  </div>


</div>






{/* Sekcija 2: STVARI KOJE SU MI VAŽNE*/}
<div className="section-banner-title banner-green" ref={greenRef} style={{ marginTop: '30px' }}>STVARI KOJE SU MI VAŽNE</div>

<div className="form-container-green">
 
 
  {/* Komunikacija */}
  <div className="field-row-green align-start">
    <img src="/komunikacijska-putovnica/icons/komunicirati.png" alt="Najlakša komunikacija" className="row-icon" />
    <div className="content-wrapper">
    <label className="row-label-small" style={{ display: 'block', color: (error && !formData.lakaKomunikacija.trim()) ? '#d32f2f' : '#333' 
                }}>Najlakše komuniciram ako:{(error && !formData.lakaKomunikacija) && <span style={{ fontSize: '12px' }}> (Obavezno polje)</span>} </label>
    <div className="input-with-counter">
      <textarea name="lakaKomunikacija" maxLength="450" placeholder="(primjerice imam dovoljno vremena, koristim simbole,  znakujem, koristim tablet, odgovaram sa DA ili NE…)" className="row-input" style={{ 
           border: (error && !formData.lakaKomunikacija.trim()) ? '2px solid #d32f2f' : '1px solid #ccfacc', 
        }} rows="6" onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.lakaKomunikacija.length >= 440 ? 'char-counter-limit' : ''}`}>
        {formData.lakaKomunikacija.length} / 450
      </span>
    </div>
    </div>
  </div>

  {/* Bol */}
  <div className="field-row-green align-start">
    <img src="/komunikacijska-putovnica/icons/bol.png" alt="Bol" className="row-icon" />
    <div className="content-wrapper">
    <label className="row-label-small" style={{ display: 'block', color: (error && !formData.bol.trim()) ? '#d32f2f' : '#333' 
                }}>Kako dajem do znanja da me boli:{(error && !formData.bol) && <span style={{ fontSize: '12px' }}> (Obavezno polje)</span>} </label>
    <div className="input-with-counter">
      <textarea name="bol" maxLength="250" placeholder="(primjerice pokazat ću na dio tijela, plakat ću i sl.)" className="row-input" style={{ 
           border: (error && !formData.bol.trim()) ? '2px solid #d32f2f' : '1px solid #ccfacc', 
        }} rows="6" onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.bol.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.bol.length} / 250
      </span>
    </div>
    </div>
  </div>

  {/* Kretanje */}
  <div className="field-row-green align-start">
    <img src="/komunikacijska-putovnica/icons/hodalica.png" alt="Kretanje" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Kako me pozicionirati i kako se krećem:</label>
    <div className="input-with-counter">
      <textarea name="kretanje" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" style={{border: '1px solid rgb(204, 250, 204)'}} onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.kretanje.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.kretanje.length} / 250 
      </span>
    </div>
    </div>
  </div>

{/* Osjetila */}
  <div className="field-row-green align-start">
    <img src="/komunikacijska-putovnica/icons/slusati.png" alt="Osjetila" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Stanje mog sluha i vida:</label>
    <div className="input-with-counter">
      <textarea name="osjetila" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" style={{border: '1px solid rgb(204, 250, 204)'}} onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.osjetila.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.osjetila.length} / 250 
      </span>
    </div>
    </div>
  </div>

  {/* Pomagala */}
  <div className="field-row-green align-start">
    <img src="/komunikacijska-putovnica/icons/pomagala.png" alt="Pomagala" className="row-icon" />
    <div className="content-wrapper">
    <label className="row-label-small" style={{ display: 'block', color: (error && !formData.pomagala.trim()) ? '#d32f2f' : '#333' 
                }}>Koristim ova pomagala: {(error && !formData.pomagala) && <span style={{ fontSize: '12px' }}> (Obavezno polje)</span>} </label>
    <div className="input-with-counter">
      <textarea name="pomagala" maxLength="250" placeholder="(npr. za kretanje hodalice ili kolica, naočale za vid, slušne aparatiće i dr.)" className="row-input" style={{ 
           border: (error && !formData.pomagala.trim()) ? '2px solid #d32f2f' : '1px solid #ccfacc', 
        }} rows="4" onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.pomagala.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.pomagala.length} / 250
      </span>
    </div>
    </div>
  </div>

  {/* Jedem i pijem */}
  <div className="field-row-green">
  <img src="/komunikacijska-putovnica/icons/jedem.png" alt="Kako jedem i pijem" className="row-icon" />
  <div className="content-wrapper">
    <div className="row-column">
    
      <div className="row-sub-field">
        <label className="row-label-small">Kako jedem: </label>
          <div className="input-with-counter">
            <textarea name="jedem" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" style={{border: '1px solid rgb(204, 250, 204)'}} onChange={handleChange}></textarea>
              <span className={`char-counter ${formData.jedem.length >= 240 ? 'char-counter-limit' : ''}`}>
                {formData.jedem.length} / 250 
              </span>
         </div>
          
      </div>


    <div className="row-sub-field">
      <label className="row-label-small">Kako pijem:</label>
      <div className="input-with-counter">
            <textarea name="pijem" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" style={{border: '1px solid rgb(204, 250, 204)'}} onChange={handleChange}></textarea>
              <span className={`char-counter ${formData.pijem.length >= 240 ? 'char-counter-limit' : ''}`}>
                {formData.pijem.length} / 250 
              </span>
         </div>
    </div>
  </div>
  </div>
</div>

 <div className="field-row-green align-start">
    <img src="/komunikacijska-putovnica/icons/spavanje.png" alt="Spavanje" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Moj ritam spavanja <span style={{ fontWeight: 'normal' }}> (specifičnosti vezane za spavanje)</span>:</label>
    <div className="input-with-counter">
      <textarea name="spavanje" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" style={{border: '1px solid rgb(204, 250, 204)'}} onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.spavanje.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.spavanje.length} / 250 
      </span>
    </div>
    </div>
  </div>

   <div className="field-row-green align-start">
    <img src="/komunikacijska-putovnica/icons/toalet.png" alt="Nužda" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Nuždu obavljam:</label>
    <div className="input-with-counter">
      <textarea name="nuzda" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" style={{border: '1px solid rgb(204, 250, 204)'}} onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.nuzda.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.nuzda.length} / 250 
      </span>
    </div>
    </div>
  </div>

 <div className="field-row-green align-start">
    <img src="/komunikacijska-putovnica/icons/pasta.png" alt="Higijena" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Kako obavljam osobnu higijenu <span style={{ fontWeight: 'normal' }}> (npr.  samostalno ili treba mi fizička podrška)</span>:</label>
    <div className="input-with-counter">
      <textarea name="higijena" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" style={{border: '1px solid rgb(204, 250, 204)'}} onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.higijena.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.higijena.length} / 250 
      </span>
    </div>
    </div>
  </div>

   <div className="field-row-green align-start">
    <img src="/komunikacijska-putovnica/icons/sigurnost.png" alt="Sigurnost" className="row-icon" />
    <div className="content-wrapper">
   <label className="row-label-small">Pazite na moju sigurnost <span style={{ fontWeight: 'normal' }}> (npr.  u kolicima mi zakopčajte pojas…)</span>:</label>
    <div className="input-with-counter">
      <textarea name="sigurnost" maxLength="250" placeholder="Slobodan unos, nije obavezno" className="row-input" rows="4" style={{border: '1px solid rgb(204, 250, 204)' }} onChange={handleChange}></textarea>
      <span className={`char-counter ${formData.sigurnost.length >= 240 ? 'char-counter-limit' : ''}`}>
        {formData.sigurnost.length} / 250 
      </span>
    </div>
    </div>
  </div>


</div>

{/* Sekcija 3: VOLIM/NE VOLIM*/}
<div className="section-banner-title banner-yellow" ref={yellowRef} style={{ marginTop: '30px' }}>VOLIM / NE VOLIM</div>

<div className="form-container-yellow" >

<div className="section-instruction-yellow" style={{ 
  padding: '10px 20px', 
  fontSize: '16px', 
  color: '#856404', 
  backgroundColor: '#fff3cd', 
  borderRadius: '8px', 
  marginBottom: '15px',
  lineHeight: '1.4',
  borderLeft: '5px solid #ffbc5e'
}}>
  U ovom odjeljku možete opisati što dijete voli i što mu ne odgovara ili učitati fotografije predmeta, igračaka ili osoba.<br></br>
U prvom dijelu možete opisati što dijete voli raditi, što ga usrećuje i sl.<br></br>
U drugom dijelu možete opisati što mu smeta (npr.  buka, jako osvjetljenje, hrana i sl.)
</div>
 
 <div className="field-group-yellow" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
    {/* --- KONTEJNER: VOLIM --- */}
  <div className="field-row-yellow" style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    padding: '20px', 
    backgroundColor: '#FFF1D8', // Svijetlo žuta pozadina reda
    borderRadius: '10px',
    gap: '15px'
  }}>
    {/* PRVI PODRED: Ikona i Naslov (jedno pored drugog, centrirano) */}
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '15px', justifyContent: 'center' }}>
      <img src="/komunikacijska-putovnica/icons/volim.png" alt="Volim" style={{ width: '50px', height: '50px' }} />
      <label className="row-label-small" style={{ width:'100%'}}>Stvari koje volim (molim postupiti):</label>
    </div>

    {/* DRUGI PODRED: Textarea */}
    <div className="input-with-counter" style={{ width: '100%', maxWidth: '600px' }}>
      <textarea 
        name="volim" 
        maxLength="450" 
        value={formData.volim}
        placeholder="Slobodan unos, nije obavezno" 
        className="row-input" 
        rows="6" 
        onChange={handleChange}
        style={{ width: '100%', textAlign: 'left', padding: '12px', borderRadius: '8px', border: '1px solid #FFD366' }}
      />
      <span className={`char-counter ${formData.volim.length >= 440 ? 'char-counter-limit' : ''}`}>
        {formData.volim.length} / 450 
      </span>
    </div>

    {/* TREĆI PODRED: Slika i Upload */}
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
      <div className="photo-preview-web" style={{ width: '140px', height: '140px', color: '#999', backgroundColor: '#ddd', border: '3px solid white', borderRadius: '8px', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {formData.photoVolim ? (
              <img key={formData.photoVolim} src={formData.photoVolim} alt="Preview" style={{ width: '100%', height: '100%', borderRadius: '5px', objectFit: 'cover' }} />
            ) : (
              <span style={{ padding: '10px', display: 'block'}}>"Nema slike. Podržani formati: JPG, PNG."</span>
            )}
      </div>
      <div className="upload-controls" style={{ marginTop: '20px' }}>
      <label className="upload-btn-label" >
        📁 Učitaj sliku
        <input type="file" style={{ display: 'none' }} accept="image/*" onChange={(e) => handleSubImageUpload(e, 'photoVolim')} />
      </label>
      </div>
    </div>
  </div>



   {/* --- KONTEJNER: NE VOLIM --- */}
  <div className="field-row-yellow" style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    padding: '20px', 
    backgroundColor: '#FFF1D8', 
    borderRadius: '10px',
    gap: '15px'
  }}>
    {/* PRVI PODRED: Ikona i Naslov */}
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '15px', justifyContent: 'center' }}>
      <img src="/komunikacijska-putovnica/icons/ne-volim.png" alt="Ne volim" style={{ width: '50px', height: '50px' }} />
      <label className="row-label-small" style={{ width:'100%'}}>Stvari koje ne volim:</label>
    </div>

    {/* DRUGI PODRED: Textarea */}
    <div className="input-with-counter" style={{ width: '100%', maxWidth: '600px' }}>
      <textarea 
        name="neVolim" 
        maxLength="450" 
        value={formData.neVolim}
        placeholder="Slobodan unos, nije obavezno" 
        className="row-input" 
        rows="6" 
        onChange={handleChange}
        style={{ width: '100%', textAlign: 'left', padding: '12px', borderRadius: '8px', border: '1px solid #FFD366' }}
      />
      <span className={`char-counter ${formData.neVolim.length >= 440 ? 'char-counter-limit' : ''}`}>
        {formData.neVolim.length} / 450 
      </span>
    </div>

    {/* TREĆI PODRED: Slika i Upload */}
     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
      <div className="photo-preview-web" style={{ width: '140px', height: '140px', color: '#999', backgroundColor: '#ddd', border: '3px solid white', borderRadius: '8px', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {formData.photoNeVolim ? (
              <img key={formData.photoNeVolim} src={formData.photoNeVolim} alt="Preview" style={{ width: '100%', height: '100%', borderRadius: '5px', objectFit: 'cover' }} />
            ) : (
              <span style={{ padding: '10px', display: 'block'}}>"Nema slike. Podržani formati: JPG, PNG."</span>
            )}
      </div>
      <div className="upload-controls" style={{ marginTop: '20px' }}>
      <label className="upload-btn-label" >
        📁 Učitaj sliku
        <input type="file" style={{ display: 'none' }} accept="image/*" onChange={(e) => handleSubImageUpload(e, 'photoNeVolim')} />
      </label>
      </div>
    </div>
  </div>

</div>
  </div>

{/* Sekcija 4: BILJEŠKE*/}
<div className="section-banner-title banner-grey" style={{ marginTop: '30px' }}>BILJEŠKE</div>

<div className="form-container-grey" >

<div className="section-instruction-grey" style={{  
  padding: '10px 20px', 
  fontSize: '16px', 
  color: '#545454', 
  backgroundColor: '#F2F2F2', 
  borderRadius: '8px', 
  marginBottom: '15px',
  lineHeight: '1.4',
  borderLeft: '5px solid #A6A6A6'
}}>
  Ovdje možete napisati još važnih podataka o djetetu.
</div>
 
 <div className="field-group-grey" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
    {/* --- KONTEJNER: VOLIM --- */}
  <div className="field-row-grey" style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    padding: '20px', 
    backgroundColor: '#f0f0f0', // Svijetlo siva pozadina reda
    borderRadius: '10px',
    gap: '15px'
  }}>
    

    {/* DRUGI PODRED: Textarea */}
    <div className="input-with-counter" style={{ width: '100%', maxWidth: '600px' }}>
      <textarea 
        name="biljeske" 
        maxLength="600" 
        value={formData.biljeske}
        placeholder="Slobodan unos, nije obavezno" 
        className="row-input" 
        rows="8" 
        onChange={handleChange}
        style={{ width: '100%', textAlign: 'left', padding: '12px', borderRadius: '8px', border: '1px solid #C0C0C0' }}
      />
      <span className={`char-counter ${formData.biljeske.length >= 590 ? 'char-counter-limit' : ''}`}>
        {formData.biljeske.length} / 600 
      </span>
    </div>
</div>

</div>

{/* --- FINALNA SEKCIJA: POTPIS I INFO --- */}
<div className="final-section-container" style={{ marginTop: '40px', borderTop: '2px solid #f0f0f0', paddingTop: '30px' }}>
  
  <div className="field-group" style={{ marginBottom: '40px' }}>
    <div className="form-row two-cols" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
      
      {/* Lijevi stupac: Podatke unio */}
      <div className="form-subcol" style={{ flex: 1, minWidth: '250px' }}>
        <div className="icon-label-pair" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/komunikacijska-putovnica/icons/potpisati.png" className="inline-icon" alt="Podatke unio" style={{ width: '60px', height: '60px' }} />
          <div style={{ flex: 1 }}>
            <div className="row-label-small" >Podatke unio:</div>
            <div >
              <input 
                type="text" 
                name="podatkeUnio"
                value={formData.podatkeUnio}
                onChange={handleChange}
                maxLength="30" 
                placeholder="Ime i prezime" 
                className="row-input"
                style={{ width: '100%', padding: '8px', border: '1px solid #C0C0C0', borderRadius: '5px' }}
              />
            </div>
          </div>
        </div>
      </div>


      {/* Desni stupac: Datum */}
      <div className="form-subcol" style={{ flex: 1, minWidth: '250px' }}>
        <div className="icon-label-pair" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="/komunikacijska-putovnica/icons/kalendar.png" className="inline-icon" alt="Datum" style={{ width: '60px', height: '60px' }} />
          <div style={{ flex: 1 }}>
            <div className="row-label-small" >Datum:</div>
            <div >
              <input 
                type="date" 
                className="row-input"
                name="datumUnosa"
                value={formData.datumUnosa}
                onChange={handleChange}
                style={{ width: '100%', padding: '8px', border: '1px solid #C0C0C0', borderRadius: '5px' }}
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  {/* INFORMACIJE O PROJEKTU */}
  <div className="project-info" style={{ 
    textAlign: 'left', 
    backgroundColor: '#f9f9f9', 
    padding: '20px', 
    borderRadius: '10px', 
    marginTop: '50px',
    fontSize: '18px',
    color: '#474747',
    border: '1px solid #eee'
  }}>
    {/*<p style={{ margin: '0 0 10px 0', color: '#000000', textAlign: 'center', }}><strong>INFORMACIJE O PROJEKTU</strong></p>*/}
    <p style={{ lineHeight: '1.6', maxWidth: '700px', margin: '0 auto' }}>
      Ovaj materijal nastao je u okviru programa <i>„Komunikacija za svako dijete – unaprjeđenje komunikacije zdravstvenih djelatnika s ranjivim skupinama djece primjenom potpomognute komunikacije i digitalne tehnologije“</i>, financiranog od strane Ureda UNICEF-a za Hrvatsku putem donacija građana i tvrtki. 
       <br />Komunikacijska putovnica izrađena je po uzoru na materijal <i>Komunikacijska putovnica Widgit Symbols</i> te sadrži ARASAAC piktograme (autor: Sergio Palao), dostupne pod licencom CC BY-NC-SA. Vlasnik resursa ARASAAC je Vlada autonomne zajednice Aragonije, Španjolska.
    </p>
    <div className="logos-container" style={{ display: 'flex', flexDirection: 'column', gap: '25px', alignItems: 'center', marginTop: '30px' }}>
    
    {/* Prvi red: ARASAAC + prva 3 logotipa */}
    <div className="logo-row-1" style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      width: '100%', 
      maxWidth: '750px', 
      flexWrap: 'wrap', 
      gap: '20px' 
    }}>
      <img src="/komunikacijska-putovnica/icons/arasaac-logo.png" alt="ARASAAC Logo" style={{ height: '45px', width: 'auto', objectFit: 'contain' }} />
      <img src="/komunikacijska-putovnica/icons/logo1.png" alt="Logo 1" style={{ height: '95px', width: 'auto', objectFit: 'contain' }} />
      <img src="/komunikacijska-putovnica/icons/logo2.png" alt="Logo 2" style={{ height: '85px', width: 'auto', objectFit: 'contain' }} />
      <img src="/komunikacijska-putovnica/icons/logo3.png" alt="Logo 3" style={{ height: '95px', width: 'auto', objectFit: 'contain' }} />
    </div>

    {/* Drugi red: Preostala 4 logotipa */}
    <div className="logo-row-2" style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      width: '100%', 
      maxWidth: '750px', 
      flexWrap: 'wrap', 
      gap: '20px' 
    }}>
      <img src="/komunikacijska-putovnica/icons/logo4.png" alt="Logo 4" style={{ height: '65px', width: 'auto', objectFit: 'contain' }} />
      <img src="/komunikacijska-putovnica/icons/logo5.png" alt="Logo 5" style={{ height: '95px', width: 'auto', objectFit: 'contain' }} />
      <img src="/komunikacijska-putovnica/icons/logo6.png" alt="Logo 6" style={{ height: '85px', width: 'auto', objectFit: 'contain' }} />
      <img src="/komunikacijska-putovnica/icons/logo7.png" alt="Logo 7" style={{ height: '85px', width: 'auto', objectFit: 'contain' }} />
    </div>


</div>
    </div>
</div>
</div>


        <button className="generate-btn" onClick={handleGenerate} style={{ backgroundColor: isReady ? '#4CAF50' : '#0077b6' }} >
         {isReady ? "✅ PODACI SPREMNI" : "PRIPREMI PDF"}
        </button>

        {!isReady && errorMsg && (
          <p style={{ color: '#d32f2f', fontWeight: 'bold', marginTop: '15px' }}>
          ⚠️ {errorMsg}
          </p>
        )}
       

          {isReady && (
  <div className="download-area" style={{ marginTop: '20px' }}>
    <PDFDownloadLink 
      document={<MyPassportPDF data={formData} />} 
      fileName={`putovnica_${formData.ime}.pdf`} 
      className="download-link"
    >
      {({ loading }) => (loading ? "Stvaranje datoteke..." : "⬇️ PREUZMI GOTOV PDF")}
    </PDFDownloadLink>
  </div>
)}
       
      </div>
    </div>
  );
}